import React from 'react';
import Selector from './components/selector/selector.js'
import './Main.scss';

function App() {
  return (
    <>
    <Selector />
    </>
  )
}

export default App;
